<button
  class="close-button"
  *ngIf="!expiredAccount"
  type="button"
  aria-label="Close"
  (click)="activeModal.dismiss()"
>
  <i class="cc-icon cc-icon-close" aria-hidden="true"></i>
</button>
<div class="sm-py-6">
  <img src="./assets/images/user/trial-expiration-background.svg" aria-hidden="true" alt="Clock image" />
</div>

<ng-container *ngIf="!expiredAccount">
  <h1 class="sm-text-xl sm-font-bold" i18n>Your free trial of Dashpivot ends {{ trialDaysLeft }}</h1>

  <p class="sm-text-center sm-text-sm" i18n data-test="upgrade-text">
    To upgrade your account or if you have questions about pricing<br />
    please contact us via livechat, or email us at <strong>info@sitemate.com</strong>
  </p>
</ng-container>

<ng-container *ngIf="expiredAccount">
  <h1 class="sm-text-xl sm-font-bold" i18n>Your 30-day free trial of Dashpivot has ended</h1>

  <p class="sm-text-center sm-text-base" data-test="end-free-trial" i18n>
    We hope you had a great experience!<br />
    You will need to subscribe to continue usage
  </p>
</ng-container>

<section class="sm-flex sm-space-x-2">
  <button
    type="button"
    class="cta-button sm-bg-default-green sm-text-white hover:sm-bg-default-dark-green"
    (click)="openLiveChat()"
  >
    <i class="cc-icon cc-icon-chat" aria-hidden="true"></i>
    <span i18n>Chat with us</span>
  </button>
  <a
    class="cta-button sm-bg-grey-1 sm-text-default-text hover:sm-bg-grey-3 hover:sm-text-default-text hover:sm-no-underline"
    href="mailto:info@sitemate.com?subject=Upgrade%20Subscription"
    role="button"
  >
    <i class="cc-icon cc-icon-send" aria-hidden="true"></i>
    <span i18n>Email us</span>
  </a>
</section>

<ng-container *ngIf="trialExpirationPeriod <= 0 && canSwitchWorkspace">
  <p class="sm-text-center sm-text-base" i18n>Have access to multiple workspaces?</p>

  <button type="button" class="cta-button sm-bg-grey-1 hover:sm-bg-grey-3" (click)="switchWorkspace()">
    <i class="cc-icon cc-icon-switch" aria-hidden="true"></i>
    <span i18n>Switch workspace</span>
  </button>
</ng-container>
